import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=32aa4208&scoped=true"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=32aa4208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa4208",
  null
  
)

export default component.exports